import { useEffect, useState } from "react";
import axios from "axios";
import { authenticatedUserAddress, getUserData } from '../../services/auth';
// import IconButton from '@mui/material/IconButton';
// import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import BaseModal from '../baseModal'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from '@mui/material/InputAdornment';
import { stacksApi } from "../../lib/constants";
import { UseGiftMessage } from "../../services/chime";
import ConfirmModal from "./ConfirmModal";
import { currencies } from "../../lib/currency";
import { clientNetwork } from "../../lib/constants";


//Import Style
import "../baseModal/styles.scss"
import './style.scss';

const GiftingModal = ({ show, setShow, authorPrincipal, giftVia, userSettings }) => {

    const [tokenbal, setTokenBal] = useState('');
    const [token, setToken] = useState(currencies[0]);

    const [amount, setAmount] = useState('');
    const [memo, setMemo] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [currentTxId, setCurrentTxId] = useState('');

    //disabled if no amount, less than 1 input or less than available balance
    const disabled = !amount || amount > tokenbal;

    let authenticatedUser = authenticatedUserAddress({ network: clientNetwork });
    //let authenticatedUser = getUserData().profile.stxAddress.mainnet;

    const handleChange = (event) => {
        switch (event.target.name) {
            case 'token':
                setToken(event.target.value)
                break;
            case 'amount':
                setAmount(event.target.value)
                break;
            case 'memo':
                setMemo(event.target.value)
                break;

            default:
                break;
        }
    };

    const handleClose = () => {
        setShow(false)
        setAmount('');
        setMemo('');
        setToken(currencies[0]);
        setTokenBal('');
    };

    // Home Chime Card(s) Action Gift, pass in the Author Principal and other properties of the Chime being Gifted. 
    const refactorBalance_value = async () => {
        const balance = await axios.get(`${userSettings?.stacksApi || stacksApi[clientNetwork]}/extended/v1/address/${authenticatedUser}/balances`);
        try {
            if (token.ftaddress === 'stacks') {
                setTokenBal(parseFloat((balance.data['stx'].balance / token.decimalfactor).toFixed(9)));
            } else {
                setTokenBal(parseFloat((balance.data['fungible_tokens'][token.ftaddress].balance / token.decimalfactor).toFixed(9)));
            }
        } catch (error) {
            setTokenBal('0');
        }
    }

    useEffect(() => {
        if (show === true) {
            refactorBalance_value();
        }
    }, [show, token, memo, tokenbal])

    return (
        <BaseModal show={show} handleClose={handleClose} aria-labelledby="parent-modal-title" aria-describedby="parent-modal-description">
            <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' }, }} noValidate autoComplete="off">
                <div id="gift-form-container">
                    <TextField id="outlined-select-currency" fullWidth select name="token" label="Select" value={token} onChange={handleChange} helperText={'Balance: ' + tokenbal}>
                        {currencies.map((option) => (
                            <MenuItem key={option.value} value={option}>
                                <img sx={{ width: 32, height: 32 }} alt={option.label} src={option.icon} />{option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField id="outlined-start-adornment" fullWidth name="amount" label="Amount" onChange={handleChange} sx={{ m: 1, width: '325ch' }} type="number" required InputProps={{ startAdornment: <InputAdornment position="start">Amount</InputAdornment>, }} />
                    <TextField id="outlined-start-adornment" fullWidth name="memo" label="Memo" onChange={handleChange} sx={{ m: 1, width: '25ch' }} InputProps={{ inputProps: { maxLength: 100, }, }} />
                    <UseGiftMessage token={token} authorPrincipal={authorPrincipal} amount={amount} memo={memo} disabled={disabled} setCurrentTxId={setCurrentTxId} setShowConfirmModal={setShowConfirmModal} giftVia={giftVia} />
                </div>
            </Box>
            <ConfirmModal show={showConfirmModal} setShow={setShowConfirmModal} txId={currentTxId} close={() => setShowConfirmModal(false)} closeGiftModal={() => handleClose()} userSettings={userSettings} />
        </BaseModal>
    );
}

export default GiftingModal;